export default "__VITE_ASSET__DGi6wnO8__"